/** Storage references are durable. Delivery URLs are resolved only at the edge. */
export function isPrivateBlobUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return (
      url.protocol === 'https:' &&
      /^[a-z0-9]+\.private\.blob\.vercel-storage\.com$/.test(url.hostname) &&
      !url.username &&
      !url.password &&
      !url.port &&
      !url.search &&
      !url.hash
    );
  } catch {
    return false;
  }
}

/** The URL is an opaque lookup key; the route never fetches unregistered URLs. */
export function fileContentUrl<T>(value: T): T {
  return (
    typeof value === 'string' && isPrivateBlobUrl(value)
      ? `/api/files/content?url=${encodeURIComponent(value)}`
      : value
  ) as T;
}
